exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu[data-v-2baf5788] {\n  display: block;\n}\n", ""]);

// exports
